import CachedIcon from '@mui/icons-material/Cached';
import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { ICandidate, IJob } from 'wisestep-api';
import { WsColors, WsButton } from 'wisestep-base';

import { getCandidateRTRStatusData } from '../../../../../features/candidates/utils/CandidateHelper';
import JobCard from '../jobCard';

interface JobListProps {
  candidates?: ICandidate[];
  onSelect: (jobId: string) => void;
  onLoadMore?: () => void;
  loadMoreText?: string;
  loadMappings?: boolean;
  isMappings?: boolean;
  selectedCandidateId?: string;
  jobs?: IJob[];
  selectedJob?: string;
}

const JobList = ({
  candidates = [],
  isMappings,
  onSelect,
  loadMoreText,
  onLoadMore,
  loadMappings,
  selectedCandidateId,
  jobs = [],
  selectedJob = '',
}: JobListProps) => {
  const checkTag = (candidate: ICandidate) => {
    if (candidate.candidateStatusTags) {
      if (candidate.candidateStatusTags.includes('applied')) {
        return 'Applied';
      } else if (candidate.candidateStatusTags.includes('submitted')) {
        return 'Submitted';
      } else {
        return 'Mapped';
      }
    }
  };

  const checkRTRStatus = (candidate: ICandidate) => {
    return getCandidateRTRStatusData(JSON.stringify(candidate.contactActionsObjs || []));
  };

  return (
    <Grid
      container
      width={'100%'}
      rowSpacing={1}
      px={2}
      py={1}
      sx={{ backgroundColor: WsColors.White }}
      mt={1}
    >
      {candidates
        ?.filter((candidate) => {
          if (isMappings) {
            return !candidate.candidateStatusTags.includes('submitted');
          }
          return true;
        })
        .map((candidate, index) => (
          <Grid item xs={12} key={index}>
            <JobCard
              key={index}
              lastUpdated={candidate.modifiedOn ?? ''}
              title={candidate.mappedJobTitle ?? ''}
              jobCode={candidate.jobCode ?? ''}
              onClick={() => {
                onSelect(selectedJob ?? '');
              }}
              isSelected={!isEmpty(selectedCandidateId) && candidate.id === selectedCandidateId}
              recruiterActions={
                candidate.applicationStage ? [candidate.applicationStage] : candidate.actions ?? []
              }
              candidateStatusTags={
                candidate.applicationState
                  ? [candidate.applicationState]
                  : candidate.candidateStatusTags
              }
              candidateStatus={checkTag(candidate)}
              updatedText={`Last updated :`}
              joinedCandidate={candidate?.applicationState ?? ''}
              currentRTRStatus={checkRTRStatus(candidate)}
            />
          </Grid>
        ))}
      {jobs.map((job, index) => (
        <Grid item xs={12} key={index}>
          <JobCard
            key={index}
            lastUpdated={job.createdOn?.toString() ?? ''}
            title={job.title ?? ''}
            jobCode={job.jobCode ?? ''}
            onClick={() => {
              onSelect(job.id ?? '');
            }}
            isSelected={job.id === selectedJob}
            recruiterActions={[]}
            candidateStatusTags={[]}
            updatedText={`Last updated :`}
            candidateStatus={
              loadMoreText && loadMoreText?.indexOf('mappings') > -1 ? 'Mapped' : 'Submitted'
            }
            // currentRTRStatus={checkRTRStatus(candidate)}
          />
        </Grid>
      ))}

      {loadMappings && onLoadMore && (
        <Grid item xs={12}>
          <WsButton startIcon={<CachedIcon />} variant="text" onClick={() => onLoadMore()}>
            {loadMoreText ?? ''}
          </WsButton>
        </Grid>
      )}
    </Grid>
  );
};
export default JobList;
